import { forEach, uniq } from 'lodash';
import { Modal, Space, Spin, message } from 'antd';
import React from 'react';
import { getAvailableVdGroups, requestVdAction } from 'services/mgmt';
import moment from 'moment';

export function getXauthFromCookie() {
  try {
    return document.cookie
      .split('; ')
      .find((r) => r.startsWith('x_auth'))
      .split('=')[1];
  } catch (_err) {
    return undefined;
  }
}

export function getStateIconInfo(localeKey) {
  let color = 'processing';
  if (
    localeKey.endsWith('state.ready') ||
    localeKey.endsWith('state.idle') ||
    localeKey.endsWith('state.connected')
  ) {
    color = 'success';
  } else if (localeKey.endsWith('state.error')) {
    color = 'error';
  } else if (localeKey.endsWith('state.disconnected') || localeKey.endsWith('state.stopped')) {
    color = 'default';
  }

  return color;
}

/*
 * 추가 삭제 시 mgmt(back-end) validation을 통과하지 못 한 경우 error fields를 골라낸다.
 */
export function getErrorFields(items) {
  // reason이 중복된 것 제거
  // FIXME : GS 인증때문에 급하게 하느라 배열 validation의 경우 index가 나오는 순간 뒤는 무시한다.
  // 검사해야할 schema를 받아서 바꾸도록 수정이 필요해보인다.
  const generateNamePath = (name) => {
    const arrayIndex = name.findIndex((n) => n.match(/\d/));

    // array
    if (arrayIndex !== -1) {
      return name.slice(0, arrayIndex);
    }

    return name;
  };

  const errObjs = {};

  forEach(items, (errItem) => {
    const namePath = generateNamePath(errItem.name);
    const nameString = namePath.join('/');
    if (!errObjs[nameString]) {
      errObjs[nameString] = [];
    }

    errObjs[nameString].push(errItem.reason);
  });

  return Object.entries(errObjs).map(([k, v]) => ({ name: k.split('/'), errors: uniq(v) }));
}

export function connectByVdStart(group, endTime, connectFn) {
  requestVdAction(group.id, 'start');
  Modal.info({
    title: '자동 접속 중',
    keyboard: false,
    content: (
      <Space direction="vertical" align="center">
        <Spin spinning />
        <div>[{group.vdName}] 자동 접속 중입니다. 잠시만 기다려주세요.</div>
      </Space>
    ),
    okButtonProps: { style: { display: 'none' } },
  });

  const intervalId = setInterval(async () => {
    const vdGroup = await getAvailableVdGroups();
    if (vdGroup.status === 503) {
      message.error(vdGroup.message);
      clearInterval(intervalId);
      Modal.destroyAll();
      return;
    }
    const groupInfo = vdGroup.data.find((g) => g.id === group.id);

    // if (!disabledFailover('connect', groupInfo.state, groupInfo.user))
    if (
      groupInfo.state.endsWith('.state.ready') ||
      groupInfo.state.endsWith('.state.idle') ||
      groupInfo.state.endsWith('.state.connected') ||
      groupInfo.state.endsWith('.state.disconnected')
    ) {
      clearInterval(intervalId);
      Modal.destroyAll();
      connectFn(groupInfo);
    }

    // 현재시간이랑 끝나야하는 시간이랑 비교해서 지났으면
    if (moment().diff(endTime) >= 0) {
      clearInterval(intervalId);
      Modal.destroyAll();

      Modal.error({
        title: '자동 접속 실패',
        content: 'VD가 접속 가능한 상태가 아닙니다.',
      });
    }
  }, 10 * 1000);

  return intervalId;
}
export function startAgent(endTime) {
  window.location = 'vdivsclagent:';
  const endTimer = moment().add(endTime || 2, 's');

  Modal.info({
    title: '프로그램 실행 중',
    keyboard: false,
    content: (
      <Space direction="vertical" align="center">
        <Spin spinning />
        <div>프로그램 실행 중입니다. 잠시만 기다려주세요.</div>
      </Space>
    ),
    okButtonProps: { style: { display: 'none' } },
  });

  return new Promise((resolve, _) => {
    const timer = setInterval(() => {
      if (moment().diff(endTimer) >= 0) {
        clearInterval(timer);
        Modal.destroyAll();
        resolve(true);
      }
    }, 2 * 1000);
  });
}
